import React from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "sonner";

import SmoothScroll from "@/components/SmoothScroll";
import Nav from "@/components/Nav";
import Hero from "@/components/Hero";
import About from "@/components/About";
import Manifesto from "@/components/Manifesto";
import Services from "@/components/Services";
import Portfolio from "@/components/Portfolio";
import Team from "@/components/Team";
import Contact from "@/components/Contact";
import WorkCategory from "@/pages/WorkCategory";
import ProjectDetail from "@/pages/ProjectDetail";
import HashScrollHandler from "@/components/HashScrollHandler";
import ScrollDownArrow from "@/components/ScrollDownArrow";

function Home() {
  return (
    <div data-testid="home-page">
      <Nav />
      <main>
        <Hero />
        <About />
        <Portfolio />
        <Manifesto />
        <Services />
        <Team />
        <Contact />
      </main>
    </div>
  );
}

function App() {
  return (
    <div className="App">
      <SmoothScroll>
        <BrowserRouter>
          <HashScrollHandler />
          <ScrollDownArrow />
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/work/:slug" element={<WorkCategory />} />
            <Route path="/work/:slug/:projectId" element={<ProjectDetail />} />
          </Routes>
        </BrowserRouter>
        <Toaster
          position="bottom-right"
          toastOptions={{
            style: {
              background: "var(--collab-ink)",
              color: "var(--collab-cream)",
              border: "1px solid var(--collab-forest)",
              borderRadius: 0,
              fontFamily: "'Inter Tight', sans-serif",
            },
          }}
        />
      </SmoothScroll>
    </div>
  );
}

export default App;
